import React, { Fragment, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { spinnerOff, spinnerOn } from '../../components/Spinner';
import { post, startFMPProject } from '../../api';

import IpsFMPProjectGrid from '../../components/ProjectsGrid/IpsFMPProjectGrid';

import IpsFMPProjectList from 'components/ProjectsList/IpsFMPProjectList';
import IPSFMPViewType from 'components/ViewType/IPSFMPViewType';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import SearchStationPendingTab from '../common/SearchStationPendingTab';
import { Button, Col } from 'antd';
import {redirect,startProjectPendingFMPProject, handleStartFMPTracker} from '../../utils/Dashboard';
import pendingData from './pending.json';

export default withRouter(function FMPTrackerPending(props) {
  const {
    context,
    history,
    cardview,
    onViewTypeChange,
    projectList,
    ipsStations,
  } = props;
  const [projects, setProjects] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  
  let tab = history.location.pathname.split('/')[2];
  useEffect(() => {
    async function getProjects() {
      if (projects && projects.length < 1) {
        spinnerOn();
        setIsLoading(true);

        const result = await post(`fmpprojects/pending`, '', {});
        if(result?.data?.length > 0){
          result.data = result.data.sort((a, b) => a.id.stationName.localeCompare(b.id.stationName));
          
        }

        setProjects(result.data);
        

        spinnerOff();
        setIsLoading(false);
      }
    }

    getProjects();
  }, []);
  
  
  function startProject(project) {
    let redirectInfo = {history,context}

    startProjectPendingFMPProject(project,ipsStations,handleStartFMPTracker ,redirectInfo);
    
  }

  return (
    <Fragment>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flewGrow: 1,
          justifyContent: 'center',
          paddingRight: '16px',
          paddingBottom: '16px',
        }}
      >
        <div style={{ flexGrow: 1 }} />
        <IPSFMPViewType
          onViewTypeChange={onViewTypeChange}
          tabView={'FMP_P'}
          tstatus={'FMP_P'}
        />
      </div>
      {cardview === 'cardview' ? (
        <IpsFMPProjectGrid
          projects={projectList(projects)}
          history={history}
          context={context}
          onButtonClick={startProject}
          isLoading={isLoading}
          {...props}
        />
      ) : (
        <IpsFMPProjectList
          projects={projectList(projects)}
          onButtonClick={startProject}
          {...props}
          tabView={tab}
        />
      )}
      {}
    </Fragment>
  );
});